/** What the Secret, Required and Cached definition flags mean: the tooltips on their grid badges and details labels */
export const FLAG_TOOLTIPS = {
	secret: "The value is a password, key or token. Keep it out of tickets, chat and screenshots.",
	required: "The code fails when this setting has no value. When it isn't required, the code uses its default.",
	cached: "The app keeps this value in memory, so a change takes effect only after the app restarts or its settings cache is cleared.",
};

/** A definition flag as the details dialog shows it; null means nobody's sure */
export const flagText = (flag?: boolean | null) => (flag == null ? "Not sure" : flag ? "Yes" : "No");
